// const count = 0;

/**
 * Noop function.
 */

function noop() {
  return;
}

declare global {
  function jsonp_dco(data: unknown): void;
}

interface JSONPOptions {
  prefix?: string;
  name?: string;
  timeout?: number;
  param?: string;
}

export function jsonp<T>(url: string, opts?: JSONPOptions): Promise<T> {
  return new Promise((resolve, reject) => {
    if (!opts) opts = {} as JSONPOptions;

    // const prefix = opts.prefix || "__jp";

    // // use the callback name that was passed if one was provided.
    // // otherwise generate a unique name by incrementing our counter.
    // const id = opts.name || prefix + count++;

    const param = opts.param || "callback";
    const timeout = null != opts.timeout ? opts.timeout : 60000;
    const enc = encodeURIComponent;
    const target = document.getElementsByTagName("script")[0] || document.head;
    const script = document.createElement("script");
    let timer;

    if (timeout) {
      timer = setTimeout(function() {
        cleanup();
        reject("Timeout");
      }, timeout);
    }

    function cleanup() {
      if (script.parentNode) script.parentNode.removeChild(script);
      window["jsonp_dco"] = noop;
      if (timer) clearTimeout(timer);
    }

    function cancel() {
      if (window["jsonp_dco"]) {
        cleanup();
      }
    }

    window["jsonp_dco"] = function(data) {
      cleanup();
      resolve(data as T);
    };

    // add qs component
    url += (~url.indexOf("?") ? "&" : "?") + param + "=" + enc("jsonp_dco");
    url = url.replace("?&", "?");

    // create script
    script.src = url;
    target.parentNode?.insertBefore(script, target);

    return cancel;
  });
}
